import * as React from "react"

export interface EpiEditModeSettings {
	inEditMode: boolean
	isEditable: boolean
	isIdle: boolean
}

export interface EpiContextValue {
	editMode: EpiEditModeSettings
}

export const EpiContext = React.createContext({
	editMode: {
		inEditMode: false,
		isEditable: false,
		isIdle: true,
	},
})

export interface EpiContextProps {
	ssrRequest?: boolean
	children: React.ReactNode
}

export const EpiContextProvider: React.FC<EpiContextProps> = (props) => {
	const [editMode, setEditMode] = React.useState({
		inEditMode: false,
		isEditable: false,
		isIdle: props.ssrRequest === true ? false : true,
	})

	React.useEffect(() => {
		const handler = () => {
			if (window?.epi?.ready) {
				setEditMode({
					inEditMode: window.epi.inEditMode,
					isEditable: window.epi.isEditable,
					isIdle: false,
				})
			} else if (window?.epi?.subscribe) {
				window.epi.subscribe("epiReady", () => {
					const contextMode = {
						inEditMode: window.epi.inEditMode,
						isEditable: window.epi.isEditable,
						isIdle: false,
					}
					setEditMode(contextMode)
				})
			} else {
				setEditMode({ inEditMode: false, isEditable: false, isIdle: false })
			}
		}

		// If window has already loaded, run handler
		if (document.readyState === "complete") {
			handler()
		} else {
			window.addEventListener("load", handler)
			return () => window.removeEventListener("load", handler)
		}
	}, [])

	return (
		<EpiContext.Provider value={{ editMode }}>
			{!editMode.isIdle && props.children}
		</EpiContext.Provider>
	)
}
